function SuccessPage() {
    return (
        <h1 className={'success'}>Feedback Sent.</h1>
    )
}

export default SuccessPage;